import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.814 16.02.494-1.39a7.01 7.01 0 1 0-4.616 0v.04l.518 1.382c-3.078.283-6.061 1.452-6.061 3.415C4.149 21.783 8.075 23 12 23s7.85-1.217 7.85-3.533c0-1.743-2.354-3.085-6.037-3.447M6.605 8.013a5.433 5.433 0 1 1 6.964 5.205.79.79 0 0 0-.526.565.8.8 0 0 0-.228.314l-.785 2.277-.848-2.285a1 1 0 0 0-.125-.204.79.79 0 0 0-.557-.667 5.495 5.495 0 0 1-3.895-5.205M12 21.43c-4.067 0-6.28-1.296-6.28-1.963s1.75-1.672 5.063-1.908l.518 1.382a.785.785 0 0 0 .73.51.785.785 0 0 0 .738-.526l.51-1.42q.106.048.22.062c3.078.275 4.782 1.296 4.782 1.9 0 .605-2.214 1.963-6.281 1.963"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.14 8.083a3.14 3.14 0 1 0-6.28 0 3.14 3.14 0 0 0 6.28 0m-4.71 0a1.57 1.57 0 1 1 3.14 0 1.57 1.57 0 0 1-3.14 0"
    }, null, -1)
  ]))]))
}
export default { render: render }